import MonitoringDashboard from './components/MonitoringDashboard';

function App() {
  return (
    <div className="App">
      <MonitoringDashboard />
    </div>
  );
}

export default App;